import React, { useContext, useState, useEffect, useRef } from 'react'
import Layout from '@/product/components/templates/Layout'
import CustomTable from '@/product/components/molecules/CustomTable'
import CustomSearch from '@/product/components/molecules/CustomSearch'
import { Button } from '@mui/material'
import { mapData } from '@/product/common/components'
import { useFormik } from 'formik'
import CustomCommonContext from '@/custom/context/common/commonContext'
import CustomDialog from '@/product/components/organisms/Dialog'

import * as Yup from 'yup'
import FullScreenPopup from '@/product/components/organisms/FullScreenPopup'
import SecondaryButton from '@/product/components/atoms/SecondaryButton'
import PrimaryButton from '@/product/components/atoms/PrimaryButton'
import SettingContext from '@/product/context/setting/settingContext'
import SettingCustomContext from '@/custom/context/setting/settingContext'
import AlertContext from '@/product/context/alert/alertContext'
import UserCommonContext from '@/product/context/userCommon/commonContext'
import CigarManage from './cigarManage'

const Cigars = () => {
    const settingcontext = useContext(SettingContext)
    const settingCustomContext = useContext(SettingCustomContext)
    const usercommoncontext = useContext(UserCommonContext)
    const alertContext = useContext(AlertContext)

    const { setAlert } = alertContext

    const { allLocations, getGlobalVariable } = useContext(CustomCommonContext)
    const [isLoading, setIsLoading] = useState(true)

    const {
        searchTableFetch,
        getCigarsUploads,
        searchTableAction,
        search_fetch_data,
        responseStatus,
        clearResponse: clearResponseCommuncation,
        searchGroupTable,
        group_table_data,
        cigarsUploadList,
    } = settingCustomContext

    const { getPreviousData, clearPreviousData, previous_data } =
        usercommoncontext

    const [changeStatus, setChangeStatus] = useState(false)
    const [options, setOptions] = useState([])
    const [optionsVitoladeSalida, setOptionsVitoladeSalida] = useState([])
    const changeChangeStatus = () => {
        setChangeStatus(!changeStatus)
    }

    useEffect(() => {
        if (
            group_table_data &&
            group_table_data.records &&
            group_table_data.records.length
        ) {
            let data = [...group_table_data.records]

            if (
                formikView.values.filters?.Marca?.value &&
                group_table_data.from === 'VitoladeSalida'
            ) {
                data = group_table_data?.records
                    .map((ele) => ({
                        show: ele.VitoladeSalida,
                        value: ele.VitoladeSalida,
                    }))
                    .filter(
                        (item, index, self) =>
                            item?.value &&
                            self.findIndex(
                                (v) =>
                                    v.value?.toLowerCase() ===
                                    item.value.toLowerCase()
                            ) === index
                    )
                    .sort((a, b) =>
                        a?.value
                            .toLowerCase()
                            .localeCompare(b.value?.toLowerCase())
                    )

                setOptionsVitoladeSalida(data)
            } else if (group_table_data.from === 'Marca') {
                data = group_table_data?.records
                    .map((ele) => ({
                        show: ele.Marca,
                        value: ele.Marca,
                    }))
                    .filter(
                        (item, index, self) =>
                            item?.value &&
                            self.findIndex(
                                (v) =>
                                    v.value?.toLowerCase() ===
                                    item.value?.toLowerCase()
                            ) === index
                    )
                    .sort((a, b) =>
                        a?.value
                            ?.toLowerCase()
                            .localeCompare(b.value?.toLowerCase())
                    )

                setOptions(data)
            }
        }
    }, [group_table_data])

    const [manage, setManage] = React.useState({
        popup: false,
        status: 'new',
        id: 0,
        record: {},
    })

    const toggleFullScreenPopup = (popup, status, id) => {
        if (popup) {
            setManage({ popup, status, id })
        } else {
            setManage({ popup, status: 'new', id: 0 })
        }
    }

    const [tableBody, setTableBody] = useState([])
    const formikSelection = useFormik({
        initialValues: {
            action: '',
            active: 0,
            id: 0,
            status: '',
            table: 'cigars',
            updateCigar: true,
        },
        onSubmit: (values) => {
            const dataValue = values
            if (
                dataValue.action === 'active' ||
                dataValue.action === 'deactive' ||
                dataValue.action === 'delete'
            ) {
                dataValue.active =
                    dataValue.action === 'delete'
                        ? 2
                        : dataValue.action === 'active'
                        ? 1
                        : 0
                delete dataValue.action
                searchTableAction(values, false, 'cigar_delete')
            }
        },
    })

    useEffect(() => {
        if (responseStatus) {
            if (
                responseStatus.from === 'cigar_create' &&
                responseStatus.status === 'success'
            ) {
                toggleFullScreenPopup(false)

                getCigarsUploads(formikView.values, 'cigars')
            } else if (
                responseStatus.from === 'cigar_delete' &&
                responseStatus.status === 'success'
            ) {
                changeChangeStatus()
                getCigarsUploads(formikView.values, 'cigars')
            }
            clearResponseCommuncation()
            // setAlert(
            //     responseStatusSetting.message,
            //     responseStatusSetting.status
            // )
        }
    }, [responseStatus])

    const validationArray = Yup.object({
        name: Yup.string().required('Required!'),
        address1: Yup.string().required('Required!'),
        city: Yup.string().required('Required!'),
        state: Yup.string().required('Required!'),
        zip: Yup.number().positive().integer().required('Required!'),
        weeklyHoursStart: Yup.string().required('Required!'),
        weeklyHoursEnd: Yup.string().required('Required!'),
        saturdayHoursStart: Yup.string().required('Required!'),
        saturdayHoursEnd: Yup.string().required('Required!'),
        sundayHoursStart: Yup.string().required('Required!'),
        sundayHoursEnd: Yup.string().required('Required!'),
    })

    const formikView = useFormik({
        initialValues: {
            page: 1,
            limit: 20,
            primaryTable: 'cigars',
            orderby: 'ci.id,desc',
            filters: true,
            filters: {
                Marca: {
                    value: '',
                    type: 'in',
                    field: 'ci.Marca',
                },
                status: {
                    value: 'removed',
                    type: 'notin',
                    field: 'ci.status',
                },
                VitoladeSalida: {
                    value: '',
                    type: 'in',
                    field: 'ci.VitoladeSalida',
                },
            },
        },
        onSubmit: (values) => {
            // values.filters.Marca.value = values.filters.Marca.value
            //     ? [values.filters.Marca.value]
            //     : ''
            // formikView.values.filters.VitoladeSalida.value = formikView.values
            //     .filters.VitoladeSalida.value
            //     ? [formikView.values.filters.VitoladeSalida.value]
            //     : ''
            getCigarsUploads(values, 'cigars')
        },
    })

    useEffect(() => {
        if (cigarsUploadList) {
            setTableBody(
                cigarsUploadList?.records?.length
                    ? cigarsUploadList.records
                    : []
            )
        }
    }, [cigarsUploadList])

    useEffect(() => {
        searchGroupTable({ table: 'cigars', groupByColumn: 'Marca' }, 'Marca')
        // formikView.values.filters.Marca.value = formikView.values.filters.Marca
        //     .value
        //     ? [formikView.values.filters.Marca.value]
        //     : ''
        // formikView.values.filters.VitoladeSalida.value = formikView.values
        //     .filters.VitoladeSalida.value
        //     ? [formikView.values.filters.VitoladeSalida.value]
        //     : ''
        getCigarsUploads(formikView.values, 'cigars')
    }, [])
    useEffect(() => {
        if (formikView.values.filters.Marca.value) {
            formikView.values.filters.VitoladeSalida.value = ''
            searchGroupTable(
                {
                    table: 'cigars',
                    groupByColumn: 'VitoladeSalida',
                    where: 'Marca',
                    value: formikView.values.filters.Marca.value,
                },
                'VitoladeSalida'
            )
        }
    }, [formikView.values.filters.Marca.value])

    const onClickEdit = (id, secondaryID, type) => {
        toggleFullScreenPopup(true, type, id)
    }

    const onClickDelete = (id, secondaryID, type) => {
        changeChangeStatus()
        formikSelection.values.action = 'delete'
        formikSelection.values.id = id
        formikSelection.values.status = 'removed'
    }

    const getMultipleAction = () => {
        let actionPush = []
        actionPush.push({
            buttonType: 'edit',
            clickType: 'edit',
            onclick: onClickEdit,
            tooltipTitle: 'Edit',
        })

        actionPush.push({
            buttonType: 'content_copy',
            clickType: 'duplicate',
            onclick: onClickEdit,
            tooltipTitle: 'Duplicate',
        })

        actionPush.push({
            buttonType: 'delete',
            clickType: 'delete',
            onclick: onClickDelete,
            tooltipTitle: 'Delete',
        })

        return actionPush
    }
    const tableValues = [
        {
            field: 'id',
            type: '',
            firstChild: true,
            sort: true,
            disablePadding: false,
            label: 'ID',
            filterable: true,
            filterField: 'id',
        },
        {
            field: 'Maker',
            type: '',
            firstChild: true,
            sort: true,
            disablePadding: false,
            label: 'Maker',
            filterable: true,
            filterField: 'Maker',
        },
        {
            field: 'MakerCountry',
            type: '',
            firstChild: true,
            sort: true,
            disablePadding: false,
            label: 'Origin',
            filterable: true,
            filterField: 'MakerCountry',
        },
        {
            field: 'CigarCountry',
            type: '',
            firstChild: true,
            sort: true,
            disablePadding: false,
            label: 'CigarCountry',
            filterable: true,
            filterField: 'CigarCountry',
        },
        {
            field: 'Marca',
            type: '',
            firstChild: true,
            sort: true,
            disablePadding: false,
            label: 'Marca',
            filterable: true,
            filterField: 'Marca',
        },
        {
            field: 'YearMarcaCreated',
            type: '',
            firstChild: true,
            sort: true,
            disablePadding: false,
            label: 'YearMarcaCreated',
            filterable: true,
            filterField: 'YearMarcaCreated',
        },
        {
            field: 'YearMarcaDiscontinued',
            type: '',
            firstChild: true,
            sort: true,
            disablePadding: false,
            label: 'YearMarcaDiscontinued',
            filterable: true,
            filterField: 'YearMarcaDiscontinued',
        },
        {
            field: 'VitoladeSalida',
            type: '',
            firstChild: true,
            sort: true,
            disablePadding: false,
            label: 'VitoladeSalida',
            filterable: true,
            filterField: 'VitoladeSalida',
        },
        {
            field: 'VitoladeGalera',
            type: '',
            firstChild: true,
            sort: true,
            disablePadding: false,
            label: 'VitoladeGalera',
            filterable: true,
            filterField: 'VitoladeGalera',
        },
        {
            field: 'CommonSizeName',
            type: '',
            firstChild: true,
            sort: true,
            disablePadding: false,
            label: 'CommonSizeName',
            filterable: true,
            filterField: 'CommonSizeName',
        },
        {
            field: 'RingGauge',
            type: '',
            firstChild: true,
            sort: true,
            disablePadding: false,
            label: 'RingGauge',
            filterable: true,
            filterField: 'RingGauge',
        },
        {
            field: 'Length',
            type: '',
            firstChild: true,
            sort: true,
            disablePadding: false,
            label: 'Length',
            filterable: true,
            filterField: 'Length',
        },
        {
            field: 'MachineMade',
            type: '',
            firstChild: true,
            sort: true,
            disablePadding: false,
            label: 'MachineMade',
            filterable: true,
            filterField: 'MachineMade',
        },
        {
            field: 'Packaging',
            type: '',
            firstChild: true,
            sort: true,
            disablePadding: false,
            label: 'Packaging',
            filterable: true,
            filterField: 'Packaging',
        },
        {
            field: 'Bands',
            type: '',
            firstChild: true,
            sort: true,
            disablePadding: false,
            label: 'Bands',
            filterable: true,
            filterField: 'Bands',
        },
        {
            field: 'Tubes',
            type: '',
            firstChild: true,
            sort: true,
            disablePadding: false,
            label: 'Tubes',
            filterable: true,
            filterField: 'Tubes',
        },
        {
            field: 'YearPackagingDiscontinued',
            type: '',
            firstChild: true,
            sort: true,
            disablePadding: false,
            label: 'YearPackagingDiscontinued',
            filterable: true,
            filterField: 'YearPackagingDiscontinued',
        },
        {
            field: 'YearVitolaCreated',
            type: '',
            firstChild: true,
            sort: true,
            disablePadding: false,
            label: 'YearVitolaCreated',
            filterable: true,
            filterField: 'YearVitolaCreated',
        },
        {
            field: 'YearCigarDiscontinued',
            type: '',
            firstChild: true,
            sort: true,
            disablePadding: false,
            label: 'YearCigarDiscontinued',
            filterable: true,
            filterField: 'YearCigarDiscontinued',
        },
        {
            field: 'Region',
            type: '',
            firstChild: true,
            sort: true,
            disablePadding: false,
            label: 'Region',
            filterable: true,
            filterField: 'Region',
        },
        {
            field: 'NumberofBoxesMade',
            type: 'number',
            firstChild: true,
            sort: true,
            disablePadding: false,
            label: 'NumberofBoxesMade',
            filterable: true,
            filterField: 'NumberofBoxesMade',
        },
        {
            field: 'TypeRelease',
            type: '',
            firstChild: true,
            sort: true,
            disablePadding: false,
            label: 'TypeRelease',
            filterable: true,
            filterField: 'TypeRelease',
        },
        {
            field: 'SpecialReleaseName',
            type: '',
            firstChild: true,
            sort: true,
            disablePadding: false,
            label: 'SpecialReleaseName',
            filterable: true,
            filterField: 'SpecialReleaseName',
        },
        {
            field: 'First_Year_Of_Seal_UV',
            type: 'number',
            firstChild: true,
            sort: true,
            disablePadding: false,
            label: 'First Year Of Seal UV',
            filterable: true,
            filterField: 'First_Year_Of_Seal_UV',
        },
        {
            field: 'Description',
            type: '',
            firstChild: true,
            sort: true,
            disablePadding: false,
            label: 'Description',
            filterable: true,
            filterField: 'Description',
        },
        {
            field: 'HSA',
            type: '',
            firstChild: true,
            sort: true,
            disablePadding: false,
            label: 'HSA',
            filterable: true,
            filterField: 'HSA',
        },
        {
            field: 'DescriptionHSA',
            type: '',
            firstChild: true,
            sort: true,
            disablePadding: false,
            label: 'Description HSA',
            filterable: true,
            filterField: 'DescriptionHSA',
        },

        // {
        //     field: 'Maker',
        //     type: '',
        //     firstChild: true,
        //     sort: true,
        //     disablePadding: false,
        //     label: 'Maker',
        //     filterable: true,
        //     filterField: 'Maker',
        // },
        // {
        //     field: 'Maker',
        //     type: '',
        //     firstChild: true,
        //     sort: true,
        //     disablePadding: false,
        //     label: 'Maker',
        //     filterable: true,
        //     filterField: 'Maker',
        // },
        // {
        //     field: 'Maker',
        //     type: '',
        //     firstChild: true,
        //     sort: true,
        //     disablePadding: false,
        //     label: 'Maker',
        //     filterable: true,
        //     filterField: 'Maker',
        // },
        // {
        //     field: 'active',
        //     condition: true,
        //     conditionValue: {
        //         formula: {
        //             key1: 'active',
        //             key2: 1,
        //             notation: '===',
        //         },
        //         true: {
        //             type: 'text',
        //             value: 'Active',
        //         },
        //         false: {
        //             type: 'text',
        //             value: 'Deactive',
        //         },
        //     },
        //     type: 'condition',
        //     sort: true,
        //     firstChild: false,
        //     disablePadding: false,
        //     label: 'Status',
        // },
        {
            name: 'action',
            field: 'action',
            type: 'button',
            isMultiple: true,
            clickID: 'id',
            sort: false,
            firstChild: false,
            disablePadding: false,
            label: 'Action',
            isMultiple: getMultipleAction(),
            tableShow: 1,
        },
    ]

    const onSelectMultiProducts = (data, action) => {
        formikSelection.values.action = action
        formikSelection.values.id = data
        if (
            action === 'active' ||
            action === 'deactive' ||
            action === 'delete'
        ) {
            if (action === 'delete') {
                getPreviousData({
                    page: 1,
                    limit: 20,
                    order: '',
                    orderby: '',
                    primaryTable: 'projects',
                    customTable: 'custom_projects',
                    similars: {
                        category: {
                            value: formikSelection.values.id,
                            type: 'arrayin',
                            field: 'p.location_id',
                        },
                    },
                })
            } else if (action === 'deactive') {
                setChangeStatus(true)
            } else {
                setChangeStatus(true)
            }
        }
    }

    useEffect(() => {
        if (previous_data) {
            if (previous_data.records.length) {
                setAlert('Previous records exists!', 'error')
                formikSelection.values.action = ''
                formikSelection.values.id = 0
                clearPreviousData()
            } else if (formikSelection.values.action) {
                setChangeStatus(true)
            }
        }
    }, [previous_data])

    const tableActions = []
    // tableActions.push(
    //     {
    //         label: 'Move to Active',
    //         icon: <span className="material-icons">check_circle</span>,
    //         onclick: onSelectMultiProducts,
    //         type: 'active',
    //     },
    //     {
    //         label: 'Move to Deactive',
    //         icon: <span className="material-icons">block</span>,
    //         onclick: onSelectMultiProducts,
    //         type: 'deactive',
    //     },
    //     {
    //         label: 'Delete Permanently',
    //         icon: <span className="material-icons">cancel</span>,
    //         onclick: onSelectMultiProducts,
    //         type: 'delete',
    //     }
    // )

    const searchInfo = [
        {
            label: 'Select Marca',
            placeholder: 'Select Marca',
            class: 'col-md-4 col-sm-6 col-12',
            type: 'select',
            name: 'Marca',
            options: options,
            filter: true,
            formik: formikView,
        },
        {
            label: 'Select VitoladeSalida',
            placeholder: 'Select VitoladeSalida',
            class: 'col-md-4 col-sm-6 col-12',
            type: 'select',
            name: 'VitoladeSalida',
            options: optionsVitoladeSalida,
            filter: true,
            formik: formikView,
        },
    ]

    return (
        <Layout>
            <div className="dashboard staticPages">
                <CustomSearch searchInfo={searchInfo} formik={formikView} />
                <div className="d-flex justify-content-between align-items-center mt-4">
                    <Button
                        id="location_add"
                        variant="outlined"
                        className="btnOutlined"
                        onClick={() => toggleFullScreenPopup(true, 'new', 0)}
                    >
                        <span className="material-icons">note_add</span>Add New
                        Cigar
                    </Button>
                </div>

                <CustomTable
                    formik={formikView.values}
                    tableBody={tableBody}
                    tableValues={tableValues}
                    tableActions={tableActions}
                    allData={cigarsUploadList}
                    changeTableFunction={getCigarsUploads}
                    fromVariable={'cigars'}
                />
            </div>
            <CigarManage
                record={cigarsUploadList?.records}
                data={manage}
                function={toggleFullScreenPopup}
            />

            <CustomDialog
                title={
                    formikSelection.values.action === 'delete'
                        ? 'Confirm'
                        : 'Change status'
                }
                open={changeStatus}
                function={changeChangeStatus}
            >
                <h5>
                    {formikSelection.values.action === 'delete'
                        ? 'Are you sure you want to delete ?'
                        : 'Are you sure you want to change the status ?'}
                </h5>
                <div className="actionWrapper">
                    <Button
                        id="location_cancel"
                        onClick={() => changeChangeStatus()}
                    >
                        Cancel
                    </Button>
                    <form
                        onSubmit={formikSelection.handleSubmit}
                        autoComplete="nofill"
                    >
                        <PrimaryButton
                            id="location_confirm"
                            type="submit"
                            label="Confirm"
                        />
                    </form>
                </div>
            </CustomDialog>
        </Layout>
    )
}
export default Cigars
